import React from 'react'

const PdfViewer = ({file}) => {
  return (
    <iframe src={file} title="Terms and conditions" width="100%" height="400px"/>
  )
}

export default PdfViewer